export default __webpack_public_path__ + "static/media/status-failed-icon.3f593115.svg";